import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles'
import {
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'

import StatusIcon from '../controls/StatusIcon'
import { timeseriesConfig } from '../../utils/TimeseriesConfig'

class HistoryView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    events: PropTypes.array.isRequired,
    timeseries: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    paper: theme.mixins.gutters({
      paddingTop: 16,
      paddingBottom: 16,
      marginTop: theme.spacing(3),
    }),
    list: {
      display: 'flex',
    },
    list_icon: {
      marginRight: theme.spacing(2),
    },
    list_text: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    centered: {
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  })

  eventWithIcon = (e) => {
    const { classes, timeseries } = this.props
    const tsConfig = timeseriesConfig(timeseries.name)
    const formattedText = tsConfig.format(e.data.value)
    const status = tsConfig.status(e.data.value)

    return (
      <div className={classes.list}>
        {status && <StatusIcon className={classes.list_icon} status={status} />}
        <Typography className={classes.list_text}>{formattedText}</Typography>
      </div>
    )
  }

  render() {
    const {
      events, classes,
    } = this.props

    // Reverse sort
    const sorted = [...events].sort((a, b) => moment(b.timestamp) - moment(a.timestamp))

    if (sorted.length > 0) {
      return (
        <Paper className={classes.paper} elevation={0}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Time</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                sorted.map((e) => (
                  <TableRow key={e.timestamp}>
                    <TableCell>{moment(e.timestamp).calendar()}</TableCell>
                    <TableCell>{this.eventWithIcon(e)}</TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </Paper>
      )
    }
    return (
      <div className={classes.centered}>
        <Typography variant="h2">Data Not Available</Typography>
      </div>
    )
  }
}

export default withStyles(HistoryView.styles)(HistoryView)
